import { render } from "./GamerFooter.vue?vue&type=template&id=404499c4&scoped=true"
const script = {}

import "./GamerFooter.vue?vue&type=style&index=0&id=404499c4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-404499c4"

export default script